import * as React from "react";
import * as _ from "lodash";
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IUpcomingSwapCallsReportResponse, IAppState } from "@nkr/store/index";
import CourierSwapCallsScheduleReportGrid from "./courier-swap-calls-schedules-grid";

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps { }

interface IStateProps {
    reports: IReportState,
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getUpcomingSwapCallsReport: (courierVendor: number) => Promise<IUpcomingSwapCallsReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
}

class CourierSwapCallsScheduleReport extends React.Component<TProps, IState> {
    render = () => {
        return (
            <div className='container'>
                <CourierSwapCallsScheduleReportGrid
                    courierVendor={this.props.app.user.courierVendor}
                    getUpcomingSwapCallsReport={this.props.getUpcomingSwapCallsReport}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getUpcomingSwapCallsReport: (courierVendor) => {
            return dispatch(ReportActionCreators.getUpcomingSwapCallsReport(courierVendor));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CourierSwapCallsScheduleReport);